import { render } from "./navTab.vue?vue&type=template&id=e9005cea&scoped=true"
import script from "./navTab.vue?vue&type=script&lang=js"
export * from "./navTab.vue?vue&type=script&lang=js"

import "./navTab.vue?vue&type=style&index=0&id=e9005cea&scoped=true&lang=css"

import exportComponent from "E:\\余思霖\\元数创梦\\School\\Clients\\student\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9005cea"]])

export default __exports__